module.exports = __webpack_public_path__ + "img/userAvatar.3a85eabc.png";